export const TOKEN_EXPIRY_MSGS = [
  'Invalid or expired refresh token',
  'Token expired',
  'No token, authorization denied',
  'Token is not valid',
];